import { useSelector } from "react-redux";
import { ConstantRunState } from "./slice";

export const useConstantRunState = () => {
    return useSelector(
        (state: { constantRun: ConstantRunState }) => state.constantRun
    );
};
